import React, {PropsWithChildren, ReactNode} from 'react';
import {Tooltip} from 'react-tooltip';
import {createPortal} from 'react-dom';
import 'react-tooltip/dist/react-tooltip.css';

export enum TooltipModifiers {
    MULTILINE_TOOLTIP = 'c-tooltip--multiline',
    HIDE_SHORT_TOOLTIP = 'c-tooltip--short',
}

interface Tooltip {
    id: string;
    className?: string;
    content: JSX.Element | string;
    place?: 'top' | 'right' | 'bottom' | 'left';
    disable?: boolean;
    hide?: boolean;
    tooltipClassModifiers?: TooltipModifiers;
    delayShow?: number;
    offset?: number;
    color?: string;
}

function TooltipWrapper(props: PropsWithChildren<Tooltip>): JSX.Element {
    const {
        id,
        className = '',
        children,
        content,
        place = 'top',
        disable = false,
        tooltipClassModifiers = '',
        delayShow,
        offset,
        hide = false,
        color,
    } = props;

    if (!hide) {
        return (
            <div className={className}>
                <div data-tooltip-id={id} style={{color}}>
                    {children}
                </div>
                {
                    createPortal(
                        <Tooltip
                            className={`c-tooltip ${tooltipClassModifiers}`}
                            style={{background: TOOLTIP_BACKGROUND_COLOR}}
                            id={id}
                            place={place}
                            hidden={disable}
                            delayShow={delayShow}
                            offset={offset}
                        >
                            {content}
                        </Tooltip>,
                        document.body
                    ) as ReactNode
                }
            </div>
        );
    }
    return <div className={className}>{children}</div>;
}

const TOOLTIP_BACKGROUND_COLOR = '#454545';

export default TooltipWrapper;
